// @core/api/endpoints/team/remove_schedule_participant.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/team';

/**
 * Remove participant from schedule
 * Performs remove operation on schedule participant.
 */
export async function RemoveScheduleParticipant(
  team_id: string,
  schedule_id: string,
  user_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/schedules/:schedule_id/participants/:user_id`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':schedule_id', encodeURIComponent(schedule_id));
  requestPath = requestPath.replace(':user_id', encodeURIComponent(user_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
